import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { I18NextModule } from 'angular-i18next';
import { Paths } from '../../enums/paths.enum';
import { RouteLabels } from '../../enums/routeLabels.enum';
import { AuthGuard } from '../../shared/auth.guard';
import { CanDeactivateGuard } from '../../shared/can-deactivate.guard';
import { AddOrEditCompanyPage } from './add-edit-company/add-edit-company.page';
import { CompaniesListPage } from './companies-list/companies-list.page';
import { CompanyDetailsPage } from './company-details/company-details.page';
import { IdValidatorGuard } from './guards/id-valudator.guard';

const routes: Routes = [
    {
        path: '',
        children: [
            { path: '', redirectTo: `${Paths.OVERVIEW}`, pathMatch: 'full' },
            {
                path: `${Paths.OVERVIEW}`,
                component: CompaniesListPage,
                canActivate: [AuthGuard],
                data: {
                    label: RouteLabels.COMPANIES_LIST,
                    canSeeNavigationLinkRoles: ['AnnualReportUser'],
                },
            },
            {
                path: `${Paths.ADD}`,
                component: AddOrEditCompanyPage,
                canActivate: [AuthGuard],
                canDeactivate: [CanDeactivateGuard],
                data: {
                    label: RouteLabels.COMPANY_PROFILE,
                    canSeeNavigationLinkRoles: ['AnnualReportUser'],
                },
            },
            {
                path: `:companyId`,
                component: CompanyDetailsPage,
                loadChildren: () =>
                    import('./company-details/company-details.module').then((m) => m.CompanyDetailsModule),
                canActivate: [AuthGuard, IdValidatorGuard],
                data: {
                    canSeeNavigationLinkRoles: ['AnnualReportUser'],
                },
            },
        ],
    },
];

@NgModule({
    imports: [CommonModule, I18NextModule, RouterModule.forChild(routes)],
})
export class CompaniesModule {}
